import { mapState, mapGetters, mapActions } from 'vuex'

export const adminSettingComputed = {
  ...mapState('adminSetting', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('adminSetting', ['getAccountList']),
}

export const adminSettingMethods = mapActions('adminSetting', [
  'fetchingAccountList',
  'resetAccountList',
  'deleteAccountById',
  'exportMemberSettingCsv',
])
